module.exports = __webpack_public_path__ + "static/media/image_61.df53a5eb.png";